<template>
  <div class="">
      <!-- <member-filter :form="form" :filterTable="filterTable"></member-filter> -->
      <div v-if="is_a_member" class="mb-3">
        <div class="row">
          <div class="col-12 col-md-10">
            <label class="akkurate-dark small d-none d-lg-block" for="search_term">Member Code</label>
            <b-form-group id="search_term" label-for="search_term">
              <b-form-input class="mt-2 field-container fields" type="text" v-model="code" placeholder="Search with member code">
              </b-form-input>
            </b-form-group>
          </div>
          <div class="d-grid gap-2 col-md-2 d-flex align-content-center justify-content-center mt-auto ">
            <b-button @click="filterTable" class="akkurate-green-btn akkurate-auth-size w-100 d-flex align-items-center justify-content-center"><i class="fas fa-search "></i><span class="d-none d-lg-block ms-2">Validate</span></b-button>
          </div>
        </div>
      </div>

      <div class="text-center text-danger my-2" v-if="isBusy && !guardianInfoLoaded">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
      <!-- Display Error message if any -->
       <p class="text-center text-danger my-2" v-if="errorMessage && is_a_member">
         {{ errorMessage }}
      </p>

      <div class="row" v-if="!is_a_member || (is_a_member && guardianInfoLoaded)">
        <div class="col-12 col-md-6 mb-2" v-if="!is_a_member">
          <div class="form-group">
          <label class="akkurate-dark d-flex justify-content-between small mb-2" for="guardian_profile_picture">
            <div>
            Passport
            Picture
            </div>
            <a class="btn btn-sm akkurate-danger-btn" @click="
            removeFile(
              'profile'
            )
            "><span class="akkurate-small text-white">
              <font-awesome-icon :icon="[
              'fas',
              'trash',
              ]" /></span></a>
          </label>
          <b-form-group id="choose_file" label-for="choose_file">
            <vue-dropzone ref="guardianProfileDropzone" @vdropzone-files-added="
            onGuardianProfilePictureUpload
            " id="dropzone" :options="dropzoneOptions
            "></vue-dropzone>
          </b-form-group>
          <!-- <label>Authorization Letter</label>
            <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
          <errors v-if="
            form
            .errors
            .profile_picture
          ">
            {{
            form
              .errors
              .profile_picture[0]
            }}
          </errors>
          </div>
        </div>


        <div class="col-12 col-md-6 mb-2" v-if="!is_a_member">
          <div class="form-group">
          <label class="akkurate-dark d-flex justify-content-between small mb-2" for="signature">
            <div>
            Signature
            (Max.
            2.5MB)
            </div>
            <a class="btn btn-sm akkurate-danger-btn" @click="
            removeFile(
              'signature'
            )
            "><span class="akkurate-small text-white">
              <font-awesome-icon :icon="[
              'fas',
              'trash',
              ]" /></span></a>
          </label>
          <b-form-group id="choose_file" label-for="choose_file">
            <vue-dropzone ref="guardianSignatureDropzone" @vdropzone-files-added="
            onGuardianSignatureUpload
            " id="dropzone" :options="dropzoneOptions" 
            :disabled="is_a_member"></vue-dropzone>
          </b-form-group>
          <!-- <label>Authorization Letter</label>
            <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
          <errors v-if="
            form
            .errors
            .signature
          ">
            {{
            form
              .errors
              .signature[0]
            }}
          </errors>
          </div>
        </div>

        <div v-if="is_a_member" class="d-flex mt-4 justify-content-center align-items-center justify-content-lg-start gap-3">
          <div class="col text-center">
            <img v-if="form.guardian_profile_path !=null" v-bind:src="form.guardian_profile_path" alt="Guardian Profile Picture" style="height: 180px" class="img-fluid text-center gallery-image" />
            <img v-else src="@/assets/img/Ghana-Card-Front.png" alt="Profile Picture" style="height: 180px" class="img-fluid text-center gallery-image" />
            <p class="mt-2 akkurate-green fw-bold">
              Profile Picture
            </p>
          </div>

          <div class="col text-center">
            <img v-bind:src="form.signature_image_path" alt="Signature" style="height:180px" class="img-fluid text-center gallery-image" />
            <p class="mt-2 akkurate-green fw-bold">Signature</p>
          </div>
        </div>
        <!-- Guardian Information -->
          <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="guardian_name">Name of Guardian</label>
              <b-form-group
              id="guardian_name"
              label-for="guardian_name">
              <b-form-input
              class="mt-1 field-container fields"
              type="text"
              placeholder="Enter Guardian Name"
              v-model="form.guardian_name"
              :disabled="is_a_member"
              ></b-form-input>
              <errors v-if="form.errors.guardian_name">
                {{ form.errors.guardian_name[0] }}
              </errors>
              </b-form-group>
          </div>
        
          <div class="col-12 col-md-6 mb-2">
              <label class="akkurate-dark small" for="guardian_phone">Phone Number</label>
              <b-form-group
              id="guardian_phone"
              label-for="guardian_phone">
              <b-form-input
              class="mt-1 field-container fields"
              type="number"
              placeholder="Enter Guardian Phone Number Eg. 0244411100"
              v-model="form.guardian_phone"
              :disabled="is_a_member"
              ></b-form-input>
              <errors v-if="form.errors.guardian_phone">
                {{ form.errors.guardian_phone[0] }}
              </errors>
              </b-form-group>
          </div>


          <div class="col-12 col-md-6 mb-2">
              <label class="akkurate-dark small" for="guardian_email">Email</label>
              <b-form-group
              id="guardian_email"
              label-for="guardian_email">
              <b-form-input
              class="mt-1 field-container fields"
              type="email"
              placeholder="Enter Email Address"
              v-model="form.guardian_email"
              :disabled="is_a_member"
              ></b-form-input>
              <errors v-if="form.errors.guardian_email">
                {{ form.errors.guardian_email[0] }}
              </errors>
              </b-form-group>
          </div>
          
          <div class="col-12 col-md-6 mb-2">
              <b-form-group
              label-for="guardian_address"
              class="mb-2">
              <template #label>
                <label class="akkurate-dark small" for="guardian_address"> Home Address </label>
              </template>
                <b-form-textarea
                class="mt-1 fields"
                id="guardian_address"
                v-model="form.guardian_address"
                :disabled="is_a_member"
                placeholder="Enter Guardian Home Address..."
              ></b-form-textarea>
            </b-form-group>
            
          </div>
      </div>
  </div>
</template>
<script>
import ApiService from '@/core/services/api.service';
import Multiselect from 'vue-multiselect'
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "GuardianForm",
  props: ['form', 'add_or_edit', 'is_a_member', 'files'],
  components: {
    Multiselect,
    vueDropzone,
  },
  data() {
    return {
      status: '',
      isBusy: false,
      guardianInfoLoaded: false,
      guardianInfo: null,
      errorMessage: '',
      code: '',
      dropzoneOptions: {
				url: "https://httpbin.org/post",
				thumbnailWidth: 100,
				maxFilesize: 0.5,
				headers: { "My-Awesome-Header": "header value" },
			},
    }
  },
  methods: {
    filterTable() {
			this.loadGuardian();
		},

    removeFile(dropzoneType) {
			let dropzone;
			switch (dropzoneType) {
				case "profile":
					dropzone = this.$refs.guardianProfileDropzone;
					break;
				case "signature":
					dropzone = this.$refs.guardianSignatureDropzone;
					break;
			}

			if (dropzone && dropzone.dropzone.files.length > 0) {
				// Remove all files
				dropzone.dropzone.removeAllFiles();
			}
		},
		onGuardianProfilePictureUpload(event) {
			this.files.guardian_profile_file = event[0];
			this.guardian_profile_file = event[0];
		},
		onGuardianSignatureUpload(event) {
			this.files.guardian_signature_file = event[0];
			this.guardian_signature_file = event[0];
		},
    async loadGuardian() {
			this.isBusy = true;
			this.$Progress.start();
      this.guardianInfoLoaded = false;

			await ApiService.get(`customers/guardian-info/${this.code}`).then(response => {
					this.isBusy = false;
					this.$Progress.finish();

          console.log('Guardian Information:', response.data);
					this.guardianInfo = response.data.data;
          this.form.guardian_code = this.code;
          this.code = '';

          this.guardianInfoLoaded = true; 

          if (this.guardianInfo) {
            this.form.guardian_name = (this.guardianInfo.first_name + (this.guardianInfo.middlename ? ' ' + this.guardianInfo.middlename : '') + ' ' + this.guardianInfo.last_name) || '';
            this.form.guardian_phone = this.guardianInfo.mobile || '';
            this.form.guardian_email = this.guardianInfo.email || '';
            this.form.guardian_address = this.guardianInfo.address || '';
            this.form.guardian_passport_pic_path = this.guardianInfo.passport_pic_path || '';
            this.form.guardian_passport_pic_name = this.guardianInfo.passport_pic_name || '';
            this.form.guardian_signature_image_path = this.guardianInfo.signature_image_path || '';
            this.form.guardian_signature_image_name = this.guardianInfo.signature_image_name || '';
          }

				}).catch((error) => {
					this.isBusy = false;
					this.$Progress.finish();
					this.errorMessage = error.response?.data?.message || 'An error occurred while fetching guardian information.';
					return []; 
				}).finally(() => {
					this.isBusy = false;
					this.$Progress.finish();
				});
		},
  }
}
</script>